import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";

import AreaToolTip from './map/AreaToolTip';
import CoveragePane from './map/CoveragePane';
import { SnowRemovalLinesPane, SnowRemovalLinesPaneParameter }  from './map/SnowRemovalLinesPane';

import '../App.css'
import 'leaflet/dist/leaflet.css';

function Map() {
    const areaColors = [
        '#C9A56F',
        '#B7C96F',
        '#6FC993',
        '#3B9980',
        '#6FC9C9',
        '#6F93C9',
        '#816FC9',
        '#294452',
        '#C96FA5',
        '#8F473C',
    ]
    const defaultOverlayOpacity = 0.6;
    const [fillOpacity, setFillOpacity] = useState(defaultOverlayOpacity);
    const [lastFetched, setLastFetched] = useState(null)

    // 今から何時間前の予測値を表示するか。
    // 0は最新の予測値
    const [snowplowPredictionPrevHour, setSnowplowPredictionPrevHour] = useState(0);
    // スライダーで変更できる目盛りの数
    const [nSnowplowPrediction, setNSnowplowPrediction] = useState(1);

    // スライダーで選択した時間帯の予測値のリスト（エリア順に並ぶ）
    const [snowplowPredictionValues, setSnowplowPredictionValues] = useState([])

    // マップ領域にマウスオーバーしたときの処理
    const handleOnMouseOver = () => {
        setFillOpacity(0);
    };
    const handleOnMouseLeave= () => {
        setFillOpacity(defaultOverlayOpacity);
    };

    const [snowRemovalLinesPaneParameters, setSnowRemovalLinesPaneParameters] = useState([]);
    const [predictions, setPredictions] = useState([]);
    const [places, setPlaces] = useState([]);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

    useEffect(() => {
        setTimeout(() => {
            axios.get(`/api/prediction/snowplows/list`)
                .then(res => {
                    // エリアの描画に必要なパラメータを設定
                    setSnowRemovalLinesPaneParameters(res.data.predictions.map((x) => new SnowRemovalLinesPaneParameter(
                        x.region
                    )));
                    // 全出動予測データを設定
                    setPredictions(res.data.predictions);
                    // スライダーの目盛り数を保存
                    setNSnowplowPrediction(res.data.predictions[0].probability_list.length);
                    // 表示する出動予測を選択（0:現在）
                    setSnowplowPredictionPrevHour(0);
                    setSnowplowPredictionValues(res.data.predictions.map((prediction) =>prediction.probability_list[0]));
                })
            setLastFetched(Date())
        }, lastFetched === null ? 0 : 3600000)
    }, [lastFetched]);


    useEffect(() => {
        axios.get('/api/places')
            .then(res => {
                setPlaces(res.data.places)
            })
    }, [])

    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setSnowplowPredictionPrevHour(nSnowplowPrediction - 1 - newValue);
        setSnowplowPredictionValues(predictions.map((prediction) =>prediction.probability_list[nSnowplowPrediction - 1 - newValue]));
    };

    return (
        <main>
            <link rel="stylesheet" href="/css/detail.css" />
            <section class="section_map">
            <div class="ly_inner ly_inner_map">
                <div class="bl_ttlInner">
                    <div class="bl_mapTop_inner">
                        <div class="bl_sectionTitle bl_sectionTitle_map">
                            <div class="el_sectionTitle_logo">
                                <img src="/img/mapPage.png" alt="" />
                            </div>
                            <div class="el_sectionTitle_name">
                                <h2>エリア地図</h2>
                            </div>
                        </div>
                        <div class="el_map_top">
                            <a href="/">
                                <p>▷TOPページ</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="bl_listInner">
                </div>
                <div class="bl_containerInner bl_containerInner_map">
                    <div class="tab-container tab-container_map">
                        <div class="tab-content active">
                            <div class="bl_contentInner">
                                <div class="bl_innerNow">
                                    <div class="bl_video bl_map">
                                        <div class="el_mapInner el_videoInner" onMouseOver={handleOnMouseOver} onMouseLeave={handleOnMouseLeave} stop>
                                            <MapContainer
                                                center={[43.941418, 141.655026]}
                                                zoom={13}
                                                scrollWheelZoom={true}
                                                style={{ width: isMobile ? '100%': 738, height: isMobile ? 300 : 438 }}
                                            >
                                                <TileLayer
                                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                <CoveragePane fillOpacity={fillOpacity} />
                                                <SnowRemovalLinesPane snowRemovalLinesPaneParameters={snowRemovalLinesPaneParameters} probabilities={snowplowPredictionValues}/>

                                                {predictions.map((prediction) => (
                                                    <AreaToolTip
                                                        areaName={prediction.area_name}
                                                        position={[prediction.label_lat, prediction.label_lon]}
                                                        color={areaColors[prediction.area_id - 1]}
                                                        rate={prediction.probability_list[snowplowPredictionPrevHour]}
                                                    />
                                                ))}
                                                {places.map((place) => (
                                                    <Marker
                                                        position={[place.lat, place.lon]}
                                                        icon={L.icon({ iconUrl: icon, iconSize: [25, 35], className: "marker", }) }
                                                        eventHandlers={{
                                                            click: (e) => {
                                                                navigate(`/place/${place.place_id}`);
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </MapContainer>
                                        </div>
                                    </div>
                                </div>
                                <div class="bl_innerForecast_map bl_innerForecast">
                                    <div class="bl_innerForecast_mapTop">
                                        {/* max値のときが現在。そこから左にスライドすると1, 2, ..., n時間前のデータを表示*/}
                                        <input class="input-type" type="range" min="0" max={nSnowplowPrediction - 1} defaultValue={nSnowplowPrediction - 1 - snowplowPredictionPrevHour} onInput={handleInputChange} />
                                    </div>
                                    <div class="bl_innerForecast_mapUnder">
                                        <div class="bl_mapUnder_left">
                                            <div class="el_mapUnder_logo">
                                                <img src="/img/timeLogo.png" alt="" />
                                            </div>
                                            <div class="el_mapUnder_ttl">
                                                <p>時間帯別予測</p>
                                            </div>
                                        </div>
                                        <div class="el_mapUnder_right">
                                            <p><span id="current-value"></span>{snowplowPredictionPrevHour == 0 ? '現在' : `${snowplowPredictionPrevHour}時間前`}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </main>
    )
}

export default Map
